module.exports = __webpack_public_path__ + "img/amara_logo.4fb4cad2.png";